import BaseHeadline from './Index.vue'

BaseHeadline.install = function(Vue) {
  Vue.component(BaseHeadline.name, BaseHeadline)
}

export default BaseHeadline
